import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { HttpParams } from '@angular/common/http';

import { TopTenCustomersDashboardService } from '../../../../Services/top-ten-customers.service';
import { FirmService } from '../../../../Services/firm.service';

@Component({
  selector: 'app-top-ten-customers',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './top-ten-customers.component.html',
  styleUrls: ['./top-ten-customers.component.css']
})
export class TopTenCustomersComponent implements OnInit {
  topFourCustomers: any[] = [];
  topTenCustomers: any[] = [];
  firms: any[] = [];
  selectedFirmId: number | null = null;

  constructor(
    private router: Router,
    private topTenCustomersDashboardService: TopTenCustomersDashboardService,
    private firmService: FirmService
  ) { }

  ngOnInit() {
    this.getFirms();
    this.getTopTenCustomers();
  }

  // ----------------------------
  // FETCH ALL FIRMS
  // ----------------------------
  getFirms() {
    this.firmService.getFirms().subscribe({
      next: (res: any) => {
        this.firms = res.data;
        console.log('Firms:', this.firms);
      },
      error: err => console.error(err)
    });
  }

  // ----------------------------
  // FIRM DROPDOWN CHANGE
  // ----------------------------
  onFirmChange(event: Event) {
    const firmId = Number((event.target as HTMLSelectElement).value);
    this.selectedFirmId = firmId || null;

    let params = new HttpParams();
    if (this.selectedFirmId) {
      params = params.set('firm_id', this.selectedFirmId.toString());
    }

    this.getTopTenCustomers(params);
  }

  // ----------------------------
  // GET TOP 10 CUSTOMERS
  // ----------------------------
  getTopTenCustomers(params: HttpParams = new HttpParams()) {
    this.topTenCustomersDashboardService.getTopTenCustomers(params).subscribe({
      next: (res: any) => {
        const customers = res.data || [];

        // Map API response to template properties
        this.topTenCustomers = customers.map((c: any, index: number) => ({
          rank: index + 1,
          name: c.in_customer_name,
          branch: c.firm_name,
          type: c.user_customer_type,
          orders: c.total_invoices,
          revenue: parseFloat(c.total_amount_paid),
          totalAmount: parseFloat(c.grand_total),
          paidAmount: parseFloat(c.total_amount_paid),
          dueAmount: parseFloat(c.balance_due),
          metalBilled: parseFloat(c.total_metal_billed || 0),
          metalReceived: parseFloat(c.total_metal_received || 0),
          metalDue: parseFloat(c.total_metal_due || 0),
          initials: c.in_customer_name
            .split(' ')
            .map((n: string) => n[0])
            .join('')
            .toUpperCase(),
          color: 'bg-indigo-100 text-indigo-700',
          lastActive: '1 day ago',
          trend: 'up'
        }));

        // Optional: top 4 for dashboard preview
        this.topFourCustomers = this.topTenCustomers.slice(0, 4);
      },
      error: err => console.error(err)
    });
  }


  goToStaffTab() {
    this.router.navigate(['/admin-dashboard'], {
      queryParams: { tab: 'staff' },
      queryParamsHandling: 'merge'
    });
  }
}
